export default "__VITE_ASSET__Dd5BdL67__"